import React, { useContext, useEffect , useState} from 'react'
import { DeviceContext } from '../photosMain';
import { Link } from 'react-router-dom';
import Skeleton from '../../../../previous/src_previous/components/pages/skelton';

const SingleRelatedSection = ({cat_id,cat_name,page,galId, folderId}) => {


                   const [catData,setCatData] = useState(null);
                   const [loading,setLoading] = useState(true)
                   const {mobile} = useContext(DeviceContext)
                   const [error,setError] = useState(null)
               
   useEffect(() =>   {
       
    
    setCatData(null)  
        const getSingleData = async() => {
         try {
     
      const res = await fetch(
        `https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=${cat_id}&start=0&limit=${mobile ? 6 : 12}`
      );

      const json = await res.json();
      const apiData = json.photosHomeByType?.filter(i => String(i.gallery_folder) !== galId);
      setCatData(apiData)
     

    } catch (err) {
      console.error("Fetch error:", err);
      setError(err.message)
    } finally {
      setLoading(false);
    }
         } 
         
         
         const getAlbumData = async() => {
         try {
   
      const res = await fetch(
        `https://teluguone.com/photos_api/photosFolderRelatedJson?galId=${galId}&start=0&limit=${mobile ? 6 : 12}`
      );

      const json = await res.json();
      const apiDat = json.photos_folder;
      const apiData = json.photos_folder?.filter(item => String(item.folder_id) !== folderId);
    
      setCatData(apiData)
     

    } catch (err) {
      console.error("Fetch error:", err);
      setError(err.message)
    } finally {
      setLoading(false);
    }
          }     



        if (page === 'single') {
         getSingleData() 
        }
         else {
         getAlbumData() 
         }  


   }, [cat_id,cat_name,galId,folderId])
  
 
    return (
     <section className="single-related-section">
    {(loading || (catData?.length > 0) || error ) && <div className="section-label">More Galleries</div>}
    { (loading || (catData?.length > 0) || error) &&  <h2 className="section-title" style={{fontSize: "clamp(1.4rem,3vw,2.2rem)"}} >{cat_name} Related <em>Photos</em></h2>}
   
        <div className="single-related-grid">
        {loading ? [0,0,0,0,0,0,0,0].map((item,index) => <Link key={index}   to="" className="card">
                           <Skeleton type={"vps-datas-img"} />
                           <div className="card-overlay" ><span>Loading..</span></div>
              </Link>
              ) :
           catData && catData.length > 0 ?   catData.map((item,index) =>
       
            <Link key={index} to={item.url_link && page === 'single' ? item.url_link.substring(item.url_link.indexOf('/single')) : item.url_link && page === 'album' ? item.url_link.substring(item.url_link.indexOf('/picture')) : ''} className="single-related-card">
                  <img src={item.stimg ? item.stimg : ''}  alt={item.title ? item.title : item.folder_name ? item.folder_name : 'single-image'} />
                  <div className="single-related-card-overlay"><span>{item.title ? item.title : item.folder_name ? item.folder_name : ''}</span></div>   
            </Link>
       
        ) : ''   
              
              }
   
         {error && <p style={{width:"100%",textAlign:"center",fontWeight:"bold",color:"black"}}>No Json Data</p>}
    
     
   
     
        </div>
   
    
         </section>
  )
}

export default SingleRelatedSection
